import * as React from 'react'
import styled, { css } from 'styled-components'
import { theme, COMMON, CommonProps, UIColorTheme } from 'global'
import { typography, TypographyProps } from 'styled-system'

interface ICheckboxProps extends UIColorTheme, CommonProps, TypographyProps {
  full?: boolean
  checked: boolean
  disabled?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  children?: React.ReactChild
}

const colors = {
  dark: theme.colors.kinkyPurple,
  light: theme.colors.white,
}

const inverseColors = {
  dark: theme.colors.white,
  light: theme.colors.kinkyPurple,
}

const colorPicker = (color: 'dark' | 'light' | undefined) =>
  colors[color as keyof typeof colors]
const inverseColorPicker = (color: 'dark' | 'light' | undefined) =>
  inverseColors[color as keyof typeof colors]

const CheckboxStyled = styled.label<ICheckboxProps>`
  ${COMMON};
  ${typography};
  ${({ uiColorTheme, checked, disabled }) =>
    css`
      display: inline-block;
      background-color: transparent;
      color: ${colorPicker(uiColorTheme)};
      border-radius: 32px;
      letter-spacing: -0.36px;
      font-weight: bold;
      line-height: 1.2;
      border: 1px solid ${colorPicker(uiColorTheme)};
      cursor: pointer;

      ${checked &&
        css`
          background-color: ${colorPicker(uiColorTheme)};
          border: 1px solid transparent;
          color: ${inverseColorPicker(uiColorTheme)};
        `}

      ${disabled &&
        css`
          opacity: 0.5;
          pointer-events: none;
        `}
    `}
`

const CheckboxInput = styled.input<ICheckboxProps & CommonProps>`
  ${COMMON};
  ${css`
    visibility: hidden;
    margin: 0;
    height: 0;
    width: 0;
  `};
`

export const Checkbox = ({
  checked,
  children,
  onChange,
  ...props
}: ICheckboxProps) => {
  return (
    // @ts-ignore
    <CheckboxStyled checked={checked} {...props}>
      <>
        <CheckboxInput type='checkbox' checked={checked} onChange={onChange} />
        <span>{children}</span>
      </>
    </CheckboxStyled>
  )
}
